module.exports = __webpack_public_path__ + "static/media/DragonVR.91dd843b.mp4";